// extracted by mini-css-extract-plugin
export default {"Form":"PredefinedSmsCreate_Form__R4Icy","FlexRow":"PredefinedSmsCreate_FlexRow__p4KMG","MessageTextareaContainer":"PredefinedSmsCreate_MessageTextareaContainer__mredN"};